export default __webpack_public_path__ + "static/media/accountVerified.0b0e6214.svg";